export default "__VITE_ASSET__BZNGe5IS__"